<template>

  <div
      class="c-section q-validation-component"
      @mouseenter="hover=true"
      @mouseleave="hover=false"
      @click="click"
      v-ripple
      :class="{
          ['section-' + code]: true,
          '--active': active,
          '--filled': isFilled
        }"
  >
    <q-field
        ref="field"
        v-model="model"
        :error="haveErrors"
        :loading="loading"
        class="c-field"
        hide-bottom-space
        lazy-rules="ondemand"
        no-error-icon
        stack-label
        borderless
    >
      <template v-if="icon && mode !== 'compact'" v-slot:prepend>
        <div class="c-col flex" :class="colClass" :style="colStyle">
          <q-icon
              :name="icon"
              class="c-icon"
              :size="iconSize"
              style=""
              :color="haveErrors ? 'red' : 'primary'"
          />
        </div>
      </template>

      <template v-slot:control>

        <div class="c-col full-width" :class="colClass" :style="colStyle">

          <div class="flex no-wrap" style="padding-bottom: 3px" v-if="!hideLabel">
            <div class="flex no-wrap -items-center">
              <div class="c-label__title q-mr-auto s-font-2xs text-grey-8">{{ label }}</div>
            </div>
            <div
                v-if="!loading && $slots['label-side']"
                class="c-label__side flex items-center q-ml-auto s-font-2xs text-grey-7"
            >
              <slot name="label-side"/>
            </div>
          </div>

          <div class="self-center full-width flex no-wrap-md q-gutter-y-sm items-center">
            <div
                class="c-content q-mr-auto"
                :class="{
                    's-font-xs': isFilled,
                    's-font-2xs text-grey-8': !isFilled,
                }"
            >
              <slot v-bind="{haveErrors}"/>
            </div>
            <slot
                v-if="!loading && $slots.side"
                class="s-font-sm"
                name="side"
            />
          </div>

          <div v-if="hint" class="s-font-xs text-grey-6 q-mt-xs">
            {{ hint }}
          </div>

          <div v-if="haveErrors && !loading" class="flex q-gutter-sm q-pt-sm">
            <div class="s-font-2xs text-red-7 q-mr-auto">
              {{ errorMessage }}
            </div>
            <slot
                v-if="$slots.errorSide"
                name="errorSide"
            />
          </div>

        </div>

      </template>
      <template v-slot:append>
        <slot
            v-if="$slots.append"
            name="append"
        />
      </template>
      <template v-slot:loading>
        <q-spinner class="q-mt-sm q-pt-xs"/>
      </template>
    </q-field>
  </div>
</template>

<script setup lang="ts">

import {
  useVorderSectionWrapper,
  VOrderSectionEmits,
  VOrderSectionWrapperProps
} from "@/components/Shop/VOrder/ui/Section/util";
import {useQuasar} from "quasar";

const $q = useQuasar()

const props = withDefaults(defineProps<VOrderSectionWrapperProps>(), {
  rules: () => [],
  loading: false,
  iconSize: '15px'
})

const emit = defineEmits<VOrderSectionEmits>()
const model = defineModel()

const {
  haveErrors,
  errorMessage,
  hover,
  isFilled,
  click
} = useVorderSectionWrapper(props, model, emit)

const {code, icon, colClass, colStyle} = props

</script>
<style lang="scss" scoped>

.c-section {
  border: 1px solid #DDDDDD;
  border-radius: 14px;
  overflow: hidden;
  height: 100%;
  position: relative;

  &.--active {
    background-color: rgba(28, 28, 28, 0.05);
    border: 1px solid $primary;
  }

  :deep(.q-icon) > img {
    height: auto;
  }
}

.c-field {
  height: 100%;
  cursor: pointer;

  :deep() {
    .q-field__prepend {
      padding-right: 4px;
    }

    .q-field__marginal {
      min-height: auto;
      height: auto;
      align-items: flex-start;
    }

    .q-field__control {
      padding-left: 6px;
      padding-right: 6px;
      //height: 100%;
      min-height: auto;
      background-color: transparent;
    }

    .q-field__native,
    .q-field__prefix,
    .q-field__suffix {
      padding-top: 1px;
      padding-bottom: 2px;
      min-height: auto;
    }

    .q-field__append {
      padding-left: 0;
    }

    .q-field__native {
      align-items: start;
      color: #000000;
      line-height: 1.1 !important;
      font-size: 15px !important;
    }

    .title {
      display: inline-block;
      color: #888;
    }
  }
}

.c-icon {
  color: $primary;
}

.c-label__title {
  font-weight: 600;
}

.c-label__side {
}

.c-col {
  min-height: 40px;
  padding-top: 12px;
  padding-bottom: 10px;
}


</style>



